(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn, { once: true }) : fn();
  const activate = (nodes, current) => nodes.forEach((node) => {
    if (!node) return;
    const active = node === current;
    node.classList.toggle('is-active', active);
    if (node.hasAttribute('aria-pressed')) node.setAttribute('aria-pressed', String(active));
    if (node.getAttribute('role') === 'tab') {
      node.setAttribute('aria-selected', String(active));
      node.tabIndex = active ? 0 : -1;
    }
  });
  const moneyText = (value) => value || '';

  const toast = (message) => {
    let node = document.querySelector('[data-lance-toast]');
    if (!node) {
      node = document.createElement('div');
      node.dataset.lanceToast = '';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      Object.assign(node.style, { position:'fixed', left:'50%', bottom:'2.2rem', transform:'translateX(-50%)', zIndex:'140', padding:'1.2rem 1.8rem', background:'#131313', color:'#fbf8ef', border:'2px solid #fbf8ef', fontWeight:'700', fontSize:'1.3rem', boxShadow:'0 12px 30px rgba(19,19,19,.35)' });
      document.body.append(node);
    }
    node.textContent = message;
    node.hidden = false;
    clearTimeout(node._timer);
    node._timer = setTimeout(() => { node.hidden = true; }, 2600);
  };

  const updateCartCount = async () => {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-lance-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });
    } catch (_) {}
  };

  const addVariant = async (id, quantity = 1) => {
    if (!id) return false;
    try {
      const response = await fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:[{ id:Number(id), quantity:Number(quantity) || 1 }] }) });
      if (!response.ok) throw new Error('Cart rejected the selected configuration.');
      await updateCartCount();
      toast('Added to cart — exact configuration confirmed.');
      return true;
    } catch (error) {
      toast(error.message || 'Could not add that configuration.');
      return false;
    }
  };

  const initMeasureHero = () => {
    document.querySelectorAll('[data-lance-measure-zone]').forEach((zone) => {
      const hair = zone.querySelector('[data-lance-measure-hair]');
      const readout = zone.querySelector('[data-lance-measure-readout]');
      if (!hair || !readout) return;
      zone.addEventListener('pointermove', (event) => {
        const rect = zone.getBoundingClientRect();
        const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
        hair.style.left = `${x}px`;
        hair.style.opacity = '1';
        readout.textContent = `${(x / 96).toFixed(1)}″ FROM DATUM A`;
        readout.style.transform = x > rect.width - 220 ? 'translateX(calc(-100% - 2rem))' : '';
      });
      zone.addEventListener('pointerleave', () => { hair.style.opacity = '0'; });
    });
  };

  const initWorkingSets = () => {
    document.querySelectorAll('[data-lance-working-set]').forEach((section) => {
      const buttons = [...section.querySelectorAll('[data-lance-set]')];
      const panels = [...section.querySelectorAll('[data-lance-set-panel]')];
      const select = (button) => {
        activate(buttons, button);
        panels.forEach((panel) => { panel.hidden = panel.dataset.lanceSetPanel !== button.dataset.lanceSet; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[nextIndex].focus();
          select(buttons[nextIndex]);
        });
      });
    });
  };

  const initWall = () => {
    document.querySelectorAll('[data-lance-tool-wall]').forEach((wall) => {
      const modeButtons = [...wall.querySelectorAll('[data-lance-wall-mode]')];
      const unitButtons = [...wall.querySelectorAll('[data-lance-unit-filter]')];
      const wallView = wall.querySelector('[data-lance-wall-view]');
      const compareView = wall.querySelector('[data-lance-compare-view]');
      const filterables = [...wall.querySelectorAll('.lance-card[data-lance-unit], .lance-compare-row[data-lance-unit]')];
      const rails = [...wall.querySelectorAll('.lance-wall-rail a')];
      const zones = [...wall.querySelectorAll('[data-lance-wall-zone]')];

      modeButtons.forEach((button) => button.addEventListener('click', () => {
        activate(modeButtons, button);
        const compare = button.dataset.lanceWallMode === 'compare';
        if (wallView) { wallView.hidden = compare; wallView.setAttribute('aria-hidden', String(compare)); }
        if (compareView) { compareView.hidden = !compare; compareView.setAttribute('aria-hidden', String(!compare)); }
      }));
      unitButtons.forEach((button) => button.addEventListener('click', () => {
        activate(unitButtons, button);
        const unit = button.dataset.lanceUnitFilter;
        filterables.forEach((node) => {
          const match = unit === 'all' || node.dataset.lanceUnit === unit || (unit !== 'both' && node.dataset.lanceUnit === 'both');
          node.style.opacity = match ? '1' : '.16';
          node.setAttribute('aria-disabled', match ? 'false' : 'true');
        });
      }));
      if (zones.length && rails.length) {
        const markRail = () => {
          let active = zones[0];
          zones.forEach((zone) => { if (zone.getBoundingClientRect().top < 190) active = zone; });
          rails.forEach((rail) => rail.classList.toggle('is-active', rail.getAttribute('href') === `#${active.id}`));
        };
        window.addEventListener('scroll', markRail, { passive:true });
        markRail();
      }

      const drawer = wall.querySelector('[data-lance-quick-view-drawer]');
      let quickViewTrigger = null;
      const close = () => {
        if (drawer) drawer.hidden = true;
        document.documentElement.style.overflow = '';
        if (quickViewTrigger) quickViewTrigger.focus();
      };
      wall.querySelectorAll('[data-lance-quick-close]').forEach((button) => button.addEventListener('click', close));
      wall.querySelectorAll('[data-lance-quick-view]').forEach((button) => button.addEventListener('click', () => {
        if (!drawer) return;
        quickViewTrigger = button;
        const set = (selector, value) => { const node = drawer.querySelector(selector); if (node) node.textContent = value; };
        set('[data-qv-family]', `QUICK VIEW · FAMILY ${button.dataset.familyTag}`);
        set('[data-qv-tag]', button.dataset.family);
        set('[data-qv-title]', button.dataset.title);
        set('[data-qv-summary]', button.dataset.summary);
        set('[data-qv-price]', button.dataset.price);
        set('[data-qv-configs]', button.dataset.configs);
        set('[data-qv-state]', button.dataset.available === 'true' ? 'AVAILABLE TO ORDER' : 'EXPLORE & RESOLVE');
        const image = drawer.querySelector('[data-qv-image]');
        if (image) { image.src = button.dataset.image; image.alt = button.dataset.title; }
        const media = drawer.querySelector('.lance-quick-view__media');
        if (media) media.style.setProperty('--qv-color', button.dataset.familyColor);
        const link = drawer.querySelector('[data-qv-url]');
        if (link) link.href = button.dataset.url;
        const add = drawer.querySelector('[data-qv-add]');
        if (add) { add.dataset.variantId = button.dataset.variantId; add.disabled = button.dataset.available !== 'true'; add.textContent = add.disabled ? 'Resolve availability on product page' : `Quick add — ${button.dataset.variantTitle}`; }
        drawer.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        drawer.querySelector('[data-lance-quick-close]')?.focus();
      }));
      const quickAdd = drawer && drawer.querySelector('[data-qv-add]');
      if (quickAdd) quickAdd.addEventListener('click', async () => { if (await addVariant(quickAdd.dataset.variantId)) close(); });
      document.addEventListener('keydown', (event) => {
        if (!drawer || drawer.hidden) return;
        if (event.key === 'Escape') close();
        if (event.key !== 'Tab') return;
        const focusable = [...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((node) => !node.hidden);
        if (!focusable.length) return;
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    });
  };

  const initFinder = () => {
    document.querySelectorAll('[data-lance-finder]').forEach((finder) => {
      const taskButtons = [...finder.querySelectorAll('[data-lance-task]')];
      const shapeButtons = [...finder.querySelectorAll('[data-lance-shape]')];
      const unitButtons = [...finder.querySelectorAll('[data-lance-unit]')];
      const steps = [...finder.querySelectorAll('[data-lance-finder-step]')];
      const candidates = [...finder.querySelectorAll('[data-lance-candidate]')];
      const count = finder.querySelector('[data-lance-finder-count]');
      const title = finder.querySelector('[data-lance-finder-title]');
      const stepLabel = finder.querySelector('[data-lance-finder-step-label]');
      const result = finder.querySelector('[data-lance-finder-result]');
      const alternatives = finder.querySelector('[data-lance-finder-alternatives]');
      const reset = finder.querySelector('[data-lance-finder-reset]');
      const back = finder.querySelector('[data-lance-finder-back]');
      let task = null, shape = null, unit = null, best = null;

      const matching = () => candidates.filter((candidate) => {
        const tasks = (candidate.dataset.tasks || '').split(/\s+/);
        return (!task || tasks.includes(task)) && (!shape || candidate.dataset.shape === shape) && (!unit || unit === 'any' || candidate.dataset.unit === unit || candidate.dataset.unit === 'both');
      }).sort((a,b) => Number(b.dataset.rank || 0) - Number(a.dataset.rank || 0));
      const showStep = (name, heading, number) => {
        steps.forEach((step) => { step.hidden = step.dataset.lanceFinderStep !== name; });
        if (title) title.textContent = heading;
        if (stepLabel) stepLabel.textContent = String(number);
        if (result) result.hidden = true;
        if (back) back.hidden = name === 'task';
      };
      const renderCandidates = () => {
        const matches = matching();
        const set = new Set(matches);
        candidates.forEach((candidate) => candidate.classList.toggle('is-dim', !set.has(candidate)));
        if (count) count.textContent = String(matches.length);
        return matches;
      };
      const resolve = () => {
        const matches = renderCandidates();
        best = matches[0] || candidates[0];
        steps.forEach((step) => { step.hidden = true; });
        if (title) title.textContent = best && best.dataset.black === 'true' ? 'Your match depends on how you stand.' : 'Your exact match.';
        if (stepLabel) stepLabel.textContent = '3';
        if (!best || !result) return;
        const set = (selector, value) => { const node = result.querySelector(selector); if (node) node.textContent = value; };
        const image = result.querySelector('[data-finder-image]');
        if (image) { image.src = best.dataset.image; image.alt = best.dataset.name; }
        set('[data-finder-name]', best.dataset.name);
        set('[data-finder-summary]', best.dataset.black === 'true' ? 'Black engraved rules are resolved by unit, working edge, reading direction, and length. Use the Orientation Lab to choose from where you stand.' : best.dataset.summary);
        set('[data-finder-config]', `RECOMMENDED: ${best.dataset.config}`);
        set('[data-finder-price]', moneyText(best.dataset.price));
        const link = result.querySelector('[data-finder-url]');
        if (link) { link.href = best.dataset.black === 'true' ? '/pages/orientation-lab' : best.dataset.url; link.textContent = best.dataset.black === 'true' ? 'Open Orientation Lab' : 'View product'; }
        const add = result.querySelector('[data-finder-add]');
        if (add) { add.dataset.variantId = best.dataset.variantId; add.disabled = best.dataset.available !== 'true' || best.dataset.black === 'true'; add.hidden = best.dataset.black === 'true'; }
        result.hidden = false;
        result.querySelector('[data-finder-name]')?.focus();
        if (alternatives) {
          const alternateMatches = matches.slice(1, 3);
          alternatives.querySelectorAll('[data-finder-alt]').forEach((link, index) => {
            const alternate = alternateMatches[index];
            link.hidden = !alternate;
            if (!alternate) return;
            link.href = alternate.dataset.url;
            const altImage = link.querySelector('img');
            if (altImage) { altImage.src = alternate.dataset.image; altImage.alt = alternate.dataset.name; }
            const altName = link.querySelector('b');
            const altTrade = link.querySelector('small');
            if (altName) altName.textContent = alternate.dataset.name;
            if (altTrade) altTrade.textContent = `${alternate.dataset.config} · ${alternate.dataset.price}`;
          });
          alternatives.hidden = alternateMatches.length === 0 || best.dataset.black === 'true';
        }
        if (reset) reset.hidden = false;
      };

      taskButtons.forEach((button) => button.addEventListener('click', () => { task = button.dataset.lanceTask; activate(taskButtons, button); shape = null; unit = null; renderCandidates(); showStep('shape','What line do you need?',2); shapeButtons.forEach((shapeButton) => { const possible = candidates.some((candidate) => (candidate.dataset.tasks || '').split(/\s+/).includes(task) && candidate.dataset.shape === shapeButton.dataset.lanceShape); shapeButton.hidden = !possible; }); }));
      shapeButtons.forEach((button) => button.addEventListener('click', () => { shape = button.dataset.lanceShape; activate(shapeButtons, button); unit = null; renderCandidates(); showStep('unit','Which unit system do you read?',3); }));
      unitButtons.forEach((button) => button.addEventListener('click', () => { unit = button.dataset.lanceUnit; activate(unitButtons, button); resolve(); }));
      const add = result && result.querySelector('[data-finder-add]');
      if (add) add.addEventListener('click', () => addVariant(add.dataset.variantId));
      if (back) back.addEventListener('click', () => {
        if (result && !result.hidden) {
          unit = best = null;
          activate(unitButtons, null);
          showStep('unit','Which unit system do you read?',3);
          unitButtons[0]?.focus();
        } else if (steps.find((step) => step.dataset.lanceFinderStep === 'unit' && !step.hidden)) {
          shape = unit = null;
          activate(shapeButtons, null);
          activate(unitButtons, null);
          showStep('shape','What line do you need?',2);
          shapeButtons.find((button) => !button.hidden)?.focus();
        } else {
          task = shape = unit = null;
          activate(taskButtons, null);
          activate(shapeButtons, null);
          showStep('task','What are you making?',1);
          taskButtons[0]?.focus();
        }
        if (alternatives) alternatives.hidden = true;
      });
      if (reset) reset.addEventListener('click', () => { task = shape = unit = best = null; activate(taskButtons, null); activate(shapeButtons, null); activate(unitButtons, null); candidates.forEach((candidate) => candidate.classList.remove('is-dim')); if (count) count.textContent = String(candidates.length); if (alternatives) alternatives.hidden = true; reset.hidden = true; showStep('task','What are you making?',1); });
      const hashTask = window.location.hash.slice(1);
      const initial = taskButtons.find((button) => button.dataset.lanceTask === hashTask);
      if (initial) initial.click();
    });
  };

  const initOrientationLab = () => {
    document.querySelectorAll('[data-lance-orientation-lab]').forEach((lab) => {
      const unitButtons = [...lab.querySelectorAll('[data-lance-unit]')];
      const edgeButtons = [...lab.querySelectorAll('[data-lance-edge]')];
      const directionButtons = [...lab.querySelectorAll('[data-lance-direction]')];
      const presets = [...lab.querySelectorAll('[data-lance-orientation-preset]')];
      const results = [...lab.querySelectorAll('[data-lance-orientation-result]')];
      const details = [...lab.querySelectorAll('[data-lance-orientation-detail]')];
      const topNumbers = lab.querySelector('[data-lance-top-numbers]');
      const bottomNumbers = lab.querySelector('[data-lance-bottom-numbers]');
      const topEdge = lab.querySelector('.lance-lab-rule__edge--top');
      const bottomEdge = lab.querySelector('.lance-lab-rule__edge--bottom');
      const zero = lab.querySelector('.lance-lab-rule__zero');
      const orientationLabel = lab.querySelector('[data-lance-orientation-label]');
      const directionLabel = lab.querySelector('[data-lance-direction-label]');
      let unit = 'english', edge = 'top', direction = 'lr';
      const key = () => unit === 'both' ? 'both' : `${unit}-${edge}-${direction}`;
      const numberMarkup = (values) => values.map((value) => `<span>${value}</span>`).join('');
      const render = () => {
        const combined = unit === 'both';
        details.forEach((node) => { node.style.opacity = combined ? '.4' : '1'; node.querySelectorAll('button').forEach((button) => { button.disabled = combined; }); });
        const inch = direction === 'lr' ? ['0','2','4','6','8','10','12'] : ['12','10','8','6','4','2','0'];
        const metric = direction === 'lr' ? ['0','5','10','15','20','25','30'] : ['30','25','20','15','10','5','0'];
        if (topNumbers) { topNumbers.innerHTML = numberMarkup(combined ? inch : (unit === 'metric' ? metric : inch)); topNumbers.style.opacity = combined || edge === 'top' ? '1' : '.12'; }
        if (bottomNumbers) { bottomNumbers.innerHTML = numberMarkup(combined ? metric : (unit === 'metric' ? metric : inch)); bottomNumbers.style.opacity = combined || edge === 'bottom' ? '1' : '.12'; }
        if (topEdge) topEdge.style.background = combined || edge === 'top' ? '#00c2ff' : 'transparent';
        if (bottomEdge) bottomEdge.style.background = combined || edge === 'bottom' ? '#ffb300' : 'transparent';
        if (zero) zero.style.left = combined ? 'calc(50% - .9rem)' : (direction === 'lr' ? '3%' : 'calc(97% - 1.8rem)');
        if (orientationLabel) orientationLabel.textContent = combined ? 'INCH + CM · EITHER SIDE' : `${unit === 'metric' ? 'CM' : 'INCH'} · ${edge.toUpperCase()} EDGE · ${direction === 'lr' ? 'L→R' : 'R→L'}`;
        if (directionLabel) directionLabel.textContent = combined ? '⇄ READS FROM EITHER SIDE' : (direction === 'lr' ? '⟶ NUMBERS CLIMB LEFT TO RIGHT' : '⟵ NUMBERS CLIMB RIGHT TO LEFT');
        results.forEach((result) => { result.hidden = result.dataset.lanceOrientationResult !== key(); });
        presets.forEach((button) => button.classList.toggle('is-active', button.dataset.lanceOrientationPreset === key()));
      };
      const choose = (nodes, dataName, value) => activate(nodes, nodes.find((node) => node.dataset[dataName] === value));
      unitButtons.forEach((button) => button.addEventListener('click', () => { unit = button.dataset.lanceUnit; activate(unitButtons, button); render(); }));
      edgeButtons.forEach((button) => button.addEventListener('click', () => { edge = button.dataset.lanceEdge; activate(edgeButtons, button); render(); }));
      directionButtons.forEach((button) => button.addEventListener('click', () => { direction = button.dataset.lanceDirection; activate(directionButtons, button); render(); }));
      lab.querySelectorAll('[data-lance-direct-edge]').forEach((button) => button.addEventListener('click', () => { if (unit === 'both') return; edge = button.dataset.lanceDirectEdge; choose(edgeButtons,'lanceEdge',edge); render(); }));
      lab.querySelectorAll('[data-lance-direct-direction]').forEach((button) => button.addEventListener('click', () => { if (unit === 'both') return; direction = button.dataset.lanceDirectDirection; choose(directionButtons,'lanceDirection',direction); render(); }));
      presets.forEach((button) => button.addEventListener('click', () => { const preset = button.dataset.lanceOrientationPreset; if (preset === 'both') unit = 'both'; else [unit,edge,direction] = preset.split('-'); choose(unitButtons,'lanceUnit',unit); choose(edgeButtons,'lanceEdge',edge); choose(directionButtons,'lanceDirection',direction); render(); }));
      results.forEach((result) => {
        const variants = [...result.querySelectorAll('[data-lance-lab-variant]')];
        const add = result.querySelector('[data-lance-lab-add]');
        const price = result.querySelector('[data-lance-lab-price]');
        variants.forEach((button) => button.addEventListener('click', () => { activate(variants, button); if (price) price.textContent = button.dataset.price; if (add) { add.dataset.variantId = button.dataset.variantId; add.disabled = button.dataset.available !== 'true'; } }));
        if (add) add.addEventListener('click', () => addVariant(add.dataset.variantId));
      });
      render();
    });
  };

  const initProduct = () => {
    document.querySelectorAll('[data-lance-product]').forEach((product) => {
      const variants = [...product.querySelectorAll('[data-lance-variant]')];
      const price = product.querySelector('[data-lance-product-price]');
      const title = product.querySelector('[data-lance-selected-title]');
      const sku = product.querySelector('[data-lance-product-sku]');
      const image = product.querySelector('.lance-pdp-gallery__main img');
      const quantity = product.querySelector('[data-lance-quantity]');
      const add = product.querySelector('[data-lance-add-to-cart]');
      const availability = product.querySelector('[data-lance-availability]');
      const mobilePrice = product.querySelector('[data-lance-mobile-price]');
      const mobileTitle = product.querySelector('[data-lance-mobile-title]');
      const mobileAdd = product.querySelector('[data-lance-mobile-add]');
      const lengths = variants.map((variant) => { const match = (variant.dataset.size || '').match(/[\d.]+/); return match ? Number(match[0]) : 0; });
      const maxLength = Math.max(...lengths, 1);
      variants.forEach((variant, index) => { const bar = variant.nextElementSibling; if (bar) bar.style.width = `${Math.max(28, lengths[index] / maxLength * 100)}%`; });
      const render = (variant) => {
        const available = variant.dataset.available === 'true';
        if (price) price.textContent = variant.dataset.price;
        if (title) title.textContent = variant.dataset.title;
        if (sku) sku.textContent = variant.dataset.sku;
        if (image && variant.dataset.image) image.src = variant.dataset.image;
        if (quantity) { quantity.min = variant.dataset.quantityMin || '1'; quantity.step = variant.dataset.quantityIncrement || '1'; if (variant.dataset.quantityMax) quantity.max = variant.dataset.quantityMax; else quantity.removeAttribute('max'); if (Number(quantity.value) < Number(quantity.min)) quantity.value = quantity.min; }
        if (add) { add.disabled = !available; add.textContent = available ? `Add to cart — ${variant.dataset.price}` : 'Currently unavailable'; }
        if (availability) { availability.textContent = available ? 'Available to order' : 'Currently unavailable'; availability.style.setProperty('--availability', available ? '#00804a' : '#b33500'); }
        if (mobilePrice) mobilePrice.textContent = variant.dataset.price;
        if (mobileTitle) mobileTitle.textContent = variant.dataset.title;
        if (mobileAdd) mobileAdd.disabled = !available;
        product.querySelectorAll('[data-lance-price-breaks]').forEach((group) => { group.hidden = group.dataset.lancePriceBreaks !== variant.value; });
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.value); window.history.replaceState({}, '', url);
      };
      variants.forEach((variant) => variant.addEventListener('change', () => render(variant)));
      const mediaButtons = [...product.querySelectorAll('[data-lance-media-src]')];
      mediaButtons.forEach((button) => button.addEventListener('click', () => {
        if (image) image.src = button.dataset.lanceMediaSrc;
        mediaButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }));
      if (mobileAdd) mobileAdd.addEventListener('click', () => { if (add) add.click(); });
    });
  };

  const initPdpModules = () => {
    document.querySelectorAll('[data-lance-pdp-module]').forEach((module) => {
      const product = module.closest('[data-lance-product]');
      const variants = product ? [...product.querySelectorAll('[data-lance-variant]')] : [];
      const cuffButtons = [...module.querySelectorAll('[data-lance-cuff-width]')];
      cuffButtons.forEach((button) => button.addEventListener('click', () => {
        activate(cuffButtons, button);
        const variant = variants[Number(button.dataset.lanceCuffWidth || 1) - 1];
        if (variant && !variant.disabled) { variant.checked = true; variant.dispatchEvent(new Event('change', { bubbles:true })); }
      }));

      const center = module.querySelector('[data-lance-center-demo]');
      if (center) {
        const buttons = [...center.querySelectorAll('[data-lance-center-width]')];
        const readout = center.querySelector('[data-lance-center-readout]');
        buttons.forEach((button) => button.addEventListener('click', () => {
          activate(buttons, button);
          const width = Number(button.dataset.lanceCenterWidth || 4);
          center.style.setProperty('--center-span', `${Math.min(44, width * 5.5)}%`);
          if (readout) readout.textContent = `⟵ ${width / 2}″   CENTER   ${width / 2}″ ⟶`;
        }));
        const initial = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
        if (initial) initial.click();
      }
    });
  };

  ready(() => {
    document.body.classList.add('lance-flagship');
    initMeasureHero();
    initWorkingSets();
    initWall();
    initFinder();
    initOrientationLab();
    initProduct();
    initPdpModules();
  });
})();
